/*
 * Copyright (C) 2025 Das Land Schleswig-Holstein vertreten durch den
 * Ministerpräsidenten des Landes Schleswig-Holstein
 * Staatskanzlei
 * Abteilung Digitalisierung und zentrales IT-Management der Landesregierung
 *
 * Lizenziert unter der EUPL, Version 1.2 oder - sobald
 * diese von der Europäischen Kommission genehmigt wurden -
 * Folgeversionen der EUPL ("Lizenz");
 * Sie dürfen dieses Werk ausschließlich gemäß
 * dieser Lizenz nutzen.
 * Eine Kopie der Lizenz finden Sie hier:
 *
 * https://joinup.ec.europa.eu/collection/eupl/eupl-text-eupl-12
 *
 * Sofern nicht durch anwendbare Rechtsvorschriften
 * gefordert oder in schriftlicher Form vereinbart, wird
 * die unter der Lizenz verbreitete Software "so wie sie
 * ist", OHNE JEGLICHE GEWÄHRLEISTUNG ODER BEDINGUNGEN -
 * ausdrücklich oder stillschweigend - verbreitet.
 * Die sprachspezifischen Genehmigungen und Beschränkungen
 * unter der Lizenz sind dem Lizenztext zu entnehmen.
 */

import { Component, Input } from '@angular/core';
import { ButtonIconName, IconConfig, RadioButtonCardComponent, RadioButtonTextVariants, RadioButtonVariants } from '@ods/system';
import { FormControlEditorAbstractComponent } from '../formcontrol-editor.abstract.component';

@Component({
  selector: 'odc-radio-button-card-editor',
  imports: [RadioButtonCardComponent],
  templateUrl: './radio-button-card-editor.component.html',
})
export class RadioButtonCardEditorComponent extends FormControlEditorAbstractComponent {
  @Input({ required: true }) label!: string;
  @Input({ required: true }) formControlName!: string;
  @Input({ required: true }) value!: string;
  @Input() variant: RadioButtonVariants['variant'];
  @Input() textWidth: RadioButtonTextVariants['width'];
  @Input() icon: ButtonIconName;
  @Input() iconConfig: IconConfig;
}
